import { createRouter, createWebHistory } from 'vue-router';
import IndexPage from './components/indexPage.vue';
import NewFleet from './components/newFleet.vue';
import LoginComponent from './components/login.vue';
import SearchFleet from './components/searchFleet.vue';
import SystemStatus from './components/systemStatus.vue';

const routes = [
  {
    path: '/indexpage',
    alias:'/',
    component: IndexPage
  },
  {
    path: '/newfleet',
    component: NewFleet
  },
  {
    path: '/searchfleet',
    component: SearchFleet
  },
  {
    path: '/system',
    component: SystemStatus
  },
  {
    path: '/login',
    component: LoginComponent
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});


export default router;
